// Core Web Vitals → spans OTel `web-vital.<NAME>` (ver conventions/Observability.md).
// Requer que initTracing() (src/tracing.ts) tenha rodado antes; caso contrário
// o tracer é um no-op do @opentelemetry/api (fail-open, sem exceção).

import { onLCP, onCLS, onINP, onTTFB, Metric } from "web-vitals";
import { trace } from "@opentelemetry/api";

import { SERVICE_NAME } from "./tracing";

/**
 * Registra os callbacks de web-vitals (v4: onLCP/onCLS/onINP/onTTFB) e emite,
 * para cada métrica, um span `web-vital.<NAME>` com o valor e o rating como
 * atributos. Fail-open: qualquer erro é engolido.
 */
export function initWebVitals(): void {
  try {
    const tracer = trace.getTracer(SERVICE_NAME);

    const report = (metric: Metric): void => {
      const span = tracer.startSpan(`web-vital.${metric.name}`);
      span.setAttribute("web_vital.name", metric.name);
      span.setAttribute("web_vital.value", metric.value);
      span.setAttribute("web_vital.rating", metric.rating);
      span.setAttribute("web_vital.id", metric.id);
      span.end();
    };

    onLCP(report);
    onCLS(report);
    onINP(report);
    onTTFB(report);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[otel] falha ao inicializar web-vitals (ignorado):", err);
  }
}

export default initWebVitals;
